var app = angular.module('directives.masterpassAuthForm');
var template = require('../templates/index.html');

app.directive('masterpassAuthForm', [
    'configs',
    '$translate',
    '$stateParams',
    '$rootScope',
    'ClientCards',
    'Localization',
    '$translate',
    'Authentication',
    function(configs, $translate, $state, $rootScope, ClientCards, Localization, $translate, Authentication) {
        return {
            restrict: 'AE',
            scope: {
              cancel: '&'
            },
            template: template,
            controller:'masterpassAuthFormCtrl'
        }
    }
]);

app.controller('masterpassAuthFormCtrl',function ($scope, $stateParams, $timeout, $rootScope, ClientCards, Localization, $translate, Authentication, PortalApi, Notification, $window, Pay, Storage) {

    $scope.ClientCards = ClientCards;
    $scope.activeTab = 'SIGN_IN';
    $scope.loader = false;
    $scope.infoState = '';
    $scope.virifyOTPCode = '';
    $scope.authFormData = {
        msisdn: '',
        pin: ''
    };
    $scope.addNewCard = {
        name: "",
        number: "",
        month: "",
        year: "",
        cvv: "",
        msisdn: ""
    };
    $scope.isLogged = Authentication.isLogged;
    $scope.authErrorTimes = 0;

    $scope.switchTab = function (tab) {
        $scope.activeTab = tab;
    };

    $scope.mpAuth = function () {
        $scope.loader = true;
        $scope.authFormData['payment_id'] = Pay.payment.id;

        PortalApi.masterpassAuth($scope.authFormData).then(function (res) {
            ClientCards.data.mpStatus = res.mp_status;
            Storage.setItem('mp_status', res.mp_status);

            switch (res.mp_status) {
                case 'AUTHORIZED':
                    $translate('MYCARDS.MASTERPASS_AUTH_SUCCESS').then(function(message) {
                        Notification.success({
                            message: message,
                            delay: 5000
                        });
                    });

                    ClientCards.getList(true).then(function (cards) {
                        if(ClientCards.listMP.length){
                            ClientCards.setClientCard(ClientCards.listMP[0], 'masterpass')
                        } else if(ClientCards.list.length) {
                            ClientCards.setClientCard(ClientCards.list[0], ClientCards.list[0].card_type)
                        }
                    });

                    $scope.cancel(false, 'close');

                    break;
                case 'CONFIRMATION_NEEDED':
                    $scope.activeTab = 'REGISTRATION';
                    $scope.infoState = 'OTP_VALIDATION_LINK';
                    break;
            }

            $scope.loader = false;
        }, function (error) {
            $scope.loader = false;
            if(!$scope.isLogged){
                $translate('ERRORS.WRONG_PASSWORD').then(function(message) {
                    Notification.error({
                        message: message,
                        delay: 5000
                    });
                });
            }
        });
    };

    $scope.mpRegistrate = function(form) {
        var data = {
            alias: form.name,
            pan: form.number.replace(/\s/gi,""),
            exp: form.year + form.month,
            cvv: form.cvv,
            msisdn: '380' + form.msisdn,
            payment_id: Pay.payment.id
        };

        $scope.loader = true;
        if($scope.isLogged) {
            delete data.msisdn;
        }

        ClientCards.addMP(data).then(function (res) {
            if( res.status == '3DS_VALIDATION' && res.secure3d) {
                Authentication.removeSession();
                $window.location.href = res.secure3d.ascUrl;
            } else if( res.status == 'OTP_VALIDATION' || res.status == 'OTP_VALIDATION_LINK') {
                $scope.infoState = res.status;
                $translate('AUTH.SMS-TIP').then(function(message) {
                    Notification.success({
                        message: message,
                        delay: 5000
                    });
                });
            } else {
                $translate('NOTIFICATION.ERROR.UNKNOWN_ERROR').then(function(message) {
                    Notification.error({
                        message: message,
                        delay: 5000
                    });
                });
            }
            $scope.loader = false;
        }, function (reason) {
            $scope.infoState = 'REGISTRATION';
            $scope.loader = false;
            $translate('NOTIFICATION.ERROR.UNKNOWN_ERROR').then(function(message) {
                Notification.error({
                    message: message,
                    delay: 5000
                });
            });
        });
    };

    $scope.validateOTP = function (code) {
        $scope.loader = true;

        var data = {
            code: code
        };

        var method = '';

        if($scope.infoState == 'OTP_VALIDATION'){
            method = 'verifyCodeMP';
        } else {
            method = 'confirmMPWalletLinkOTP';
        }
        ClientCards[method](data).then(function (res) {
            if( res.status == '3DS_VALIDATION' && res.secure3d) {
                Authentication.removeSession();
                $window.location.href = res.secure3d.ascUrl;
            } else if (res.status === 'success') {
                ClientCards.data.mpStatus = res.mp_status;
                Storage.setItem('mp_status', res.mp_status);

                $translate('MYCARDS.MASTERPASS_AUTH_SUCCESS').then(function(message) {
                    Notification.success({
                        message: message,
                        delay: 5000
                    });
                });

                ClientCards.getList(true).then(function (cards) {
                    if(ClientCards.listMP.length){
                        ClientCards.setClientCard(ClientCards.listMP[0], 'masterpass')
                    } else if(ClientCards.list.length) {
                        ClientCards.setClientCard(ClientCards.list[0], ClientCards.list[0].card_type)
                    }
                });
            }
            $scope.cancel(false, 'close');
            $scope.loader = false;
        }, function (error) {
            $scope.loader = false;

            if($scope.authErrorTimes >= 2){
                $scope.activeTab = 'SIGN_IN';
                $scope.infoState = 'SIGN_IN';
                ClientCards.data.mpStatus = '';
                Storage.removeItem('mp_status');
            } else {
                Localization.notifyTemplate('error', 'ERRORS.OTP_INVALID', 5, true);
                $scope.authErrorTimes++;
            }
        })
    };

    $scope.init = function () {
        if($stateParams.infoState) {
            $scope.infoState = $stateParams.infoState;
        }
        if(Authentication.isLogged){
            switch (ClientCards.data.mpStatus) {
                case 'REGISTRATION_NEEDED':
                    $scope.infoState = 'REGISTRATION';
                    $scope.activeTab = 'REGISTRATION';
                    break;
                case 'CONFIRMATION_NEEDED':
                    $scope.loader = true;
                    ClientCards.initMPWalletLink('').then(function () {
                        $scope.infoState = 'OTP_VALIDATION_LINK';
                        $scope.loader = false;
                    }, function (reason) {

                        Notification.error({
                            message: reason,
                            delay: 5000
                        });

                        $scope.loader = false;
                    });
                    $scope.activeTab = 'REGISTRATION';
                    break;
            }
        } else if ($stateParams.infoState) {
            $scope.infoState = $stateParams.infoState;
        } else {
            $scope.infoState = 'REGISTRATION';
        }

    };
    $scope.init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/masterpassAuthForm/directives/masterpassAuthForm.js
 ** module id = 180
 ** module chunks = 1
 **/